module.exports = __webpack_public_path__ + "966ff64f5180c8a8a9459d8d595a0b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/banner_0.png
// module id = 930
// module chunks = 3